import styled from 'styled-components';
import Text from '@text';
import themedColor from '../../../../styles/theme/themed-color';
import themedFontSize from '../../../../styles/theme/themed-font-size';
import styleUtils from '../../../../styles/style.utils';

const Container = styled.div`
  color: ${themedColor('TEXT_BLUE')};
  font-size: ${themedFontSize('FORM')};
  font-weight: 400;
  margin-bottom: ${styleUtils.px(16)};
  display: flex;
  justify-content: space-between;
`;
const StyledText = styled(Text)`
  &.ucf-paragraph {
    display: inline;
    margin-bottom: 0;
    color: ${themedColor('TEXT_BLUE')};
    font-size: ${themedFontSize('FORM')};
  }
`;

const RequiredMark = styled.span`
  display: inline;
  margin-left: ${styleUtils.px(4)};
`;

const Legend = styled.p`
  &.ucf-paragraph {
    display: inline;
    font-size: ${themedFontSize('ATTACHMENT_DESC')};
    font-weight: 400;
    margin: 0;
    color: ${themedColor('TEXT_BLUE')};
  }
`;

const FieldLabelComponents = { Container, StyledText, RequiredMark, Legend };
export default FieldLabelComponents;
